<template>
  <v-btn
      v-if="hasPermission"
      height="auto"
      :block="block"
      :to="to"
      :href="href"
      :target="target"
      @click="$emit('click', $event)">
    <div class="east" :style="{backgroundImage: `url('${icon}')`}"></div>
    <div class="west">
      <h1>{{ title }}</h1>
      <h2 v-if="subtitle">{{ subtitle }}</h2>
    </div>
    <v-icon class="arrow">mdi-arrow-right-thick</v-icon>
  </v-btn>
</template>

<script>

import PermissionMixin from "@/utils/PermissionMixin";

export default {
  name: "EasyNav",
  mixins: [PermissionMixin],
  props: {
    type: {
      type: String,
      default: 'box'
    },
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    block: {
      type: Boolean,
      default: false
    },
    to: {
      type: [String, Object],
    },
    href: {
      type: [String, Object],
    },
    target: {
      type: String
    }
  },
  inject: {
    easyNavAvailable: {
      default: null
    }
  },
  created() {
    if(this.easyNavAvailable) {
      this.easyNavAvailable(this.hasPermission);
    }
  },
  computed: {
    hasPermission() {
      const to = this.to || this.href;
      if(!to) {
        return true;
      }
      return this.hasPagePermission(to);
    }
  }
}
</script>

<style lang="scss" scoped src="./easy.scss"></style>
<style lang="scss" scoped>
.v-btn {
  padding: 0 !important;
  margin: 2rem 0;

  ::v-deep .v-btn__content {
    min-height: 5rem;
    background-color: #F5F5F5;
    display: flex;
    align-items: stretch;
    padding: 1rem 1rem 1rem 0;
  }
}

.east {
  width: 100px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.west {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  margin-left: 1rem;

  h1 {
    display: block;
    font-size: 1.5rem;
    text-align: start;
  }

  h2 {
    margin-top: 0.5rem;
    display: block;
    color: #9FA0A0;
    font-size: 0.8rem;
    text-align: start;
    width: calc(100% - 30px);
    white-space: normal;
  }
}

.arrow {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
}
</style>
